const forPromise = (list, callback, duration) => {
  let promise = Promise.resolve();

  for (let index = 0; index < list.length; index++) {
    const data = list[index];
    promise = promise.then(() => {
      if (callback && typeof callback === 'function') {
        callback(data, index);
      }
      return new Promise(resolve => {
        setTimeout(resolve, duration || 1000);
      });
    });
  }
};

export default forPromise;
